import React from 'react';
import {
  Box, Button, HStack, Menu, MenuButton, MenuItem, MenuList, Text,
} from '@chakra-ui/react';
import { FiCheck, FiChevronDown, FiUsers } from 'react-icons/fi';
import useUsers from '../hooks/useUsers';
import UserChip from './UserChip';
import { UserDto } from '../models/user';

// item 386 — pick teammates to invite into the Slack channel at link time. Each pick
// is matched to a Slack account by email server-side; people without Slack are
// reported back in the toast rather than failing the link.
const SlackInvitePicker: React.FC<{
  selected: string[];
  onChange: (ids: string[]) => void;
}> = ({ selected, onChange }) => {
  const { data } = useUsers();
  const roster = (data?.index ?? []).filter((u: UserDto) => !u.isArchive);
  const toggle = (id: string) => onChange(
    selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id],
  );

  return (
    <Menu closeOnSelect={false}>
      <MenuButton
        as={Button}
        size="sm"
        variant="outline"
        w="full"
        leftIcon={<FiUsers />}
        rightIcon={<FiChevronDown />}
      >
        {selected.length === 0 ? 'Invite teammates (optional)' : `Invite ${selected.length} teammate${selected.length === 1 ? '' : 's'}`}
      </MenuButton>
      {/* item 403c — solid bg + popover-tier z-index (this Menu lives inside the
          link Popover) and a row-aligned maxH so names don't clip mid-row */}
      <MenuList fontSize="sm" maxH="320px" overflowY="auto" zIndex="popover">
        {roster.map((u: UserDto) => (
          <MenuItem
            key={u.id}
            icon={selected.includes(u.id) ? <FiCheck /> : <Box w="14px" />}
            onClick={() => toggle(u.id)}
          >
            <HStack spacing={2}>
              <UserChip userId={u.id} name={u.name} photoUrl={u.photoUrl} size="sm" showName={false} />
              <Text>{u.name}</Text>
            </HStack>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default SlackInvitePicker;
